import React, { useState } from "react";
import StyledSwitch from "src/components/StyledSwitch";
import CheckBlueIcon from "src/img/Blue-check.svg";
import CheckGreenIcon from "src/img/Green-Check.svg";
import SearchIcon from "src/img/new/search-gray.svg";
import {
    SearchBar,
    AllUserToggler,
    FlexRow,
    UsersListContainer,
    Table,
    TH,
    TD,
    Row,
    CheckImage,
    CircleCheckbox,
} from "./Leadership.style";
import { FlexContainer, LottieLoadingIndicator, TextInputWithIcon } from "src/components";
import { FILTER_BY } from "./constants";
import { customNames } from "src/utils/helpers";
import { KEYS } from "./LeadershipRoles";

const ToggleAllUsersSwitch = (props) => (
    <StyledSwitch
        switchMargin={8}
        checkedTrackColor="#1A61FF"
        thumbBorderColor="#bdbdbd"
        trackBackgroundColor="#00000029"
        trackHeight={20}
        trackRadius={23 / 2}
        {...props}
    />
);

const LeadershipTable = ({
    usersList = [],
    selectedUserGroupType = FILTER_BY.EMPLOYEE,
    allEmployeesSelected = false,
    allClientsSelected = false,
    handleAllSwitch = () => {},
    selectedUsers = [],
    onUserToggle = () => {},
    onVisibilityToggle = () => {},
    isLoading = false,
}) => {
    const [searchKey, setSearchKey] = useState("");

    const filteredUsers = usersList.filter((user) => {
        if (!searchKey) return true;
        const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
        return (
            fullName.includes(searchKey.toLowerCase()) ||
            user.department?.toLowerCase().includes(searchKey.toLowerCase()) ||
            user.jobTitle?.toLowerCase().includes(searchKey.toLowerCase())
        );
    });

    const VISIBLE_ROWS = 6;
    const renderEmptyRows = () => {
        const emptyRows = VISIBLE_ROWS - filteredUsers.length;
        if (emptyRows <= 0) return null;

        return Array.from({ length: emptyRows }, (_, index) => (
            <tr key={`empty-row-${index}`}>
                <TD>&nbsp;</TD>
                <TD></TD>
                <TD></TD>
                <TD></TD>
                <TD></TD>
                <TD></TD>
            </tr>
        ));
    };

    return (
        <FlexContainer marginTop="-20px">
            {isLoading ? (
                <LottieLoadingIndicator />
            ) : (
                <>
                    <FlexRow>
                        <TextInputWithIcon
                            iconSrc={SearchIcon}
                            iconPosition="right"
                            iconWidth="24px"
                            iconHeight="24px"
                        >
                            <SearchBar
                                placeholder={`Search ${customNames.employees}`}
                                value={searchKey}
                                onChange={(e) => setSearchKey(e.target.value)}
                            />
                        </TextInputWithIcon>
                        <AllUserToggler>
                            <span>
                                All {selectedUserGroupType === FILTER_BY.EMPLOYEE ? customNames.employees : customNames.clients}
                            </span>
                            <ToggleAllUsersSwitch
                                checked={selectedUserGroupType === FILTER_BY.CLIENT ? allClientsSelected : allEmployeesSelected}
                                onChange={(e) => handleAllSwitch(selectedUserGroupType, e.target.checked)}
                            />
                        </AllUserToggler>
                    </FlexRow>

                    <UsersListContainer>
                        <Table>
                            <thead>
                                <tr>
                                    <TH style={{ width: "150px" }}>Name</TH>
                                    <TH style={{ width: "150px" }}>Department / Group</TH>
                                    <TH>Job Title</TH>
                                    <TH style={{ width: "150px" }}>Visible to {customNames.employees}</TH>
                                    <TH style={{ width: "150px" }}>Visible to {customNames.clients}</TH>
                                    <TH>Assign User</TH>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUsers.map((user) => (
                                    <Row key={user.uuid}>
                                        <TD>{user.firstName} {user.lastName}</TD>
                                        <TD>{user.department || "-"}</TD>
                                        <TD>{user.employmentPosition || "-"}</TD>
                                        <TD>
                                            <CircleCheckbox
                                                bgColor={user.isVisibleToEmployees ? "#1A61FF" : "#fff"}
                                                onClick={() => onVisibilityToggle(user.uuid, KEYS.isVisibleToEmployees)}
                                                style={{ border: user.isVisibleToEmployees ? "none" : "1px solid #DBE5ED" }}
                                            >
                                                {user.isVisibleToEmployees && <CheckImage src={CheckBlueIcon} />}
                                            </CircleCheckbox>
                                        </TD>

                                        <TD>
                                            <CircleCheckbox
                                                bgColor={user.isVisibleToClients ? "#1A61FF" : "#fff"}
                                                onClick={() => onVisibilityToggle(user.uuid, KEYS.isVisibleToClients)}
                                                style={{ border: user.isVisibleToClients ? "none" : "1px solid #DBE5ED" }}
                                            >
                                                {user.isVisibleToClients && <CheckImage src={CheckBlueIcon} />}
                                            </CircleCheckbox>
                                        </TD>
                                        <TD>
                                            <CircleCheckbox
                                                bgColor={selectedUsers.includes(user.uuid) ? "#76C00D" : "#fff"}
                                                onClick={() => onUserToggle(user.uuid, !selectedUsers.includes(user.uuid))}
                                                style={{ border: selectedUsers.includes(user.uuid) ? "none" : "1px solid #000000" }}
                                            >
                                                {selectedUsers.includes(user.uuid) && <CheckImage src={CheckGreenIcon} />}
                                            </CircleCheckbox>
                                        </TD>
                                    </Row>
                                ))}
                                {renderEmptyRows()}
                            </tbody>
                        </Table>
                    </UsersListContainer>
                </>
            )}
        </FlexContainer>
    );
};

export default LeadershipTable;
